import { Box, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import SectionTitle from './SectionTitle';
import ServicesList from './ServicesList';

const PREFIX = 'ServicesMobile';

const classes = {
  container: `${PREFIX}-container`,
  detailContainer: `${PREFIX}-detailContainer`,
  headerContainer: `${PREFIX}-headerContainer`,
  title: `${PREFIX}-title`,
};

const StyledGrid = styled(Grid)(({ theme }) => ({
  [`&.${classes.container}`]: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'stretch',
    padding: theme.spacing(2, 2, 1, 2),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(1, 1, 0, 1),
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(1, 2),
    },
  },

  [`&.${classes.detailContainer}`]: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'stretch',
    padding: theme.spacing(0),
  },

  [`& .${classes.headerContainer}`]: {
    padding: theme.spacing(2),
  },

  [`& .${classes.title}`]: {
    marginBottom: theme.spacing(0),
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(1),
    },
  },
}));

const ServicesMobile = ({ services, detail = false }) => {
  const { t } = useTranslation('workOrdersTable');

  return (
    <StyledGrid
      container
      className={`${detail ? classes.detailContainer : classes.container}`}
    >
      <Grid item>
        <Box className={`${detail ? classes.headerContainer : ''}`}>
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid item className={classes.title}>
              <SectionTitle
                title={t('card.visibleContent.services')}
                subsection={true}
              />
            </Grid>
          </Grid>
        </Box>
      </Grid>
      <Grid item>
        {services ? <ServicesList services={services} detail={detail} /> : null}
      </Grid>
    </StyledGrid>
  );
};

export default ServicesMobile;
